import { lazy } from 'react';
import { RouteObject } from 'react-router-dom';

const HomePage = lazy(() => import('../pages/home/page'));
const PumaPage = lazy(() => import('../pages/puma/page'));
const NotFound = lazy(() => import('../pages/NotFound'));

const routes: RouteObject[] = [
  {
    path: '/',
    element: <HomePage />,
  },
  {
    path: '/puma',
    element: <PumaPage />,
  },
  {
    path: '*',
    element: <NotFound />,
  },
];

export default routes;
